
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lEf8v", function(module, exports) {
/**
 * React convenience for subscribing to remix commands for the lifetime of a
 * component. Ref-backed so the handler can close over fresh props/state without
 * re-subscribing each render (subscribe once, never stale).
 *
 * Typical use: a small component mounted near the remix surface that reacts to
 * commands — e.g. open chat on `RemixErrored`, toggle a plugin on
 * `RemixStarted`/`RemixGenerationEnded`/`RemixFlowEnded`.
 *
 * Additive; not wired into live flows.
 */ 
var $cozmU = parcelRequire("cozmU");


var $2sIE1 = parcelRequire("2sIE1");

const $e3010bf86102dcbc$export$b0620fc038952e0c = (handler)=>{
    const ref = (0, $cozmU.useRef)(handler);
    ref.current = handler;
    (0, $cozmU.useEffect)(()=>{
        // Stable proxy dispatching to the latest handler via the ref, so the
        // subscription is created once yet never goes stale.
        return (0, $2sIE1.registerRemixCommandHandler)((command)=>ref.current(command));
    }, []);
};
module.exports["useRemixCommands"] = $e3010bf86102dcbc$export$b0620fc038952e0c;

});

parcelRegister("nkPkg", function(module, exports) {
/**
 * Shared semantic vocabulary for renderer and editor parity events.
 *
 * Phase pairs remain useful diagnostic context, but consumers should use these fields to decide
 * whether an event is ordinary timing mechanics or a rollout-significant divergence.
 */ const $9d5a049440311a2a$export$9bde4969f49d9b2b = (durationMs)=>{
    if (durationMs < 250) return 'under-250ms';
    if (durationMs < 1000) return '250-999ms';
    if (durationMs < 5000) return '1-4s';
    return '5s-or-more';
};
module.exports["durationBucketForMs"] = $9d5a049440311a2a$export$9bde4969f49d9b2b;

});

parcelRegister("koSDQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irnO2 = parcelRequire("irnO2");


var $caVF7 = parcelRequire("caVF7");

const $2e4059893c92a637$export$654bbdda10638776 = ({ entryPoint: entryPoint, experienceTracker: experienceTracker, dynamicUiType: dynamicUiType, selectedSubTypeRef: selectedSubTypeRef, openAIFCStagingModalRef: openAIFCStagingModalRef, isRemixCancelledRef: isRemixCancelledRef, conversationIdRef: conversationIdRef, shouldOpenPreview: shouldOpenPreview, onAfterOpenPreview: onAfterOpenPreview })=>{
    const openPreview = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).REMIX_START
        });
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
            id: (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
            attributes: {
                product: 'confluence',
                remixType: dynamicUiType,
                remixSubtype: selectedSubTypeRef.current,
                entryPoint: entryPoint,
                conversationChannelId: conversationIdRef?.current
            }
        });
        openAIFCStagingModalRef.current();
        onAfterOpenPreview?.();
    }, [
        entryPoint,
        experienceTracker,
        dynamicUiType,
        selectedSubTypeRef,
        openAIFCStagingModalRef,
        conversationIdRef,
        onAfterOpenPreview
    ]);
    const openPreviewIfAllowed = (0, $cozmU.useCallback)(()=>{
        if (shouldOpenPreview?.() === false) return;
        openPreview();
    }, [
        openPreview,
        shouldOpenPreview
    ]);
    const { showProgressBar: showProgressBar, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, signalActionReady: signalActionReady, resetCompletion: resetCompletion } = (0, $caVF7.useRemixThinkingBarProgress)({
        onOpenPreview: openPreviewIfAllowed
    });
    const onActionReady = (0, $cozmU.useCallback)(()=>{
        if (!isRemixCancelledRef.current) {
            (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).ACTION_COMPLETE_RECEIVED);
            signalActionReady();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ref identity is stable; reading .current does not need to be a dep
    }, [
        signalActionReady
    ]);
    return {
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        onActionReady: onActionReady,
        resetCompletion: resetCompletion
    };
};
module.exports["useRemixPreviewFlow"] = $2e4059893c92a637$export$654bbdda10638776;

});

parcelRegister("7rLBD", function(module, exports) {

var $hpFQM = parcelRequire("hpFQM");

const $40851a06f2d6c64a$export$cd08f5c9e05f94dd = (contentId, cloudID, contentType)=>{
    if (!contentType) return '';
    return `ari:cloud:confluence:${cloudID}:${contentType}/${contentId}`;
};
const $40851a06f2d6c64a$export$8530183f316e301c = (activationId, cloudId)=>`ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
const $40851a06f2d6c64a$export$b381579634332aed = (curatedDefinition)=>{
    const curatedDefinitionReference = curatedDefinition.confluenceEntity;
    return {
        nlpResult: curatedDefinition.definition,
        uniqueSources: curatedDefinitionReference ? [
            {
                id: curatedDefinitionReference?.id || '',
                title: curatedDefinitionReference?.title || '',
                url: curatedDefinition.referenceUrl || '',
                type: curatedDefinitionReference?.type || '',
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: curatedDefinitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: curatedDefinition.editor?.name ? {
            name: curatedDefinition.editor.name || '',
            id: curatedDefinition.editor.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN
    };
};
const $40851a06f2d6c64a$export$479750843803fc13 = 5;
const $40851a06f2d6c64a$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["generatePageARI"] = $40851a06f2d6c64a$export$cd08f5c9e05f94dd;
module.exports["generateWorkspaceId"] = $40851a06f2d6c64a$export$8530183f316e301c;
module.exports["READING_AIDS_MAX_WORD_COUNT"] = $40851a06f2d6c64a$export$479750843803fc13;
module.exports["getHighlightCategories"] = $40851a06f2d6c64a$export$f600f3124ea5916b;

});

parcelRegister("aKDZB", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $irnO2 = parcelRequire("irnO2");


var $kDDrf = parcelRequire("kDDrf");


var $bjY3F = parcelRequire("bjY3F");


var $8akfd = parcelRequire("8akfd");


var $8GyO5 = parcelRequire("8GyO5");


var $gRoSG = parcelRequire("gRoSG");


var $aXWtB = parcelRequire("aXWtB");


var $1AJi3 = parcelRequire("1AJi3");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $jyA9t = parcelRequire("jyA9t");


var $3OD5k = parcelRequire("3OD5k");


var $3rRes = parcelRequire("3rRes");


var $81UEG = parcelRequire("81UEG");


var $iMLPM = parcelRequire("iMLPM");


var $fj6ez = parcelRequire("fj6ez");


var $dnbZ2 = parcelRequire("dnbZ2");


var $koSDQ = parcelRequire("koSDQ");


var $7GTyD = parcelRequire("7GTyD");


var $alDoy = parcelRequire("alDoy");


var $7eOZ4 = parcelRequire("7eOZ4");


var $jNS1v = parcelRequire("jNS1v");


var $etOkO = parcelRequire("etOkO");


var $8L2yq = parcelRequire("8L2yq");


var $hxqA6 = parcelRequire("hxqA6");

const $c9c8b9d550aa1c05$var$constructDynamicUiSource = (adfDocument, selectionContext, contentType)=>{
    const fragmentAdf = (0, $3rRes.prepareRemixFragmentNodes)(selectionContext?.selectionFragment ?? null);
    return {
        contentType: contentType,
        startLocalId: selectionContext?.localIds?.[0] ?? '',
        endLocalId: selectionContext?.localIds?.[selectionContext.localIds.length - 1] ?? '',
        startIndex: selectionContext?.startIndex ?? 0,
        endIndex: selectionContext?.endIndex ?? -1,
        // When the entire page is selected (e.g. cmd+a), selectionContext is null and
        // selectionFragment is not populated. Fall back to the full document content
        // so that Remix still receives the source content it needs.
        fragmentAdf: fragmentAdf ?? adfDocument.content,
        fullAdf: adfDocument
    };
};
const $c9c8b9d550aa1c05$var$RENDERER_SELECTION_CONSUME_ONCE_KEY = 'renderer-selection-remix';
const $c9c8b9d550aa1c05$var$publishRendererRemixHandoffFailed = ()=>{
    // `rovo-remix-handoff-failed` is not in the merged PubSub Payload union yet,
    // so TypeScript will not accept it as a `publish()` argument without a cast.
    (0, $hdBxM.publish)((0, $k1Pvg.Topics).ROVO_REMIX, {
        type: 'rovo-remix-handoff-failed',
        source: $c9c8b9d550aa1c05$var$RENDERER_SELECTION_CONSUME_ONCE_KEY
    });
};
const $c9c8b9d550aa1c05$var$isRendererSelectionSubmit = (payload)=>payload.type === 'submit-rovo-remix' && payload.data.remixConsumer === 'renderer' && payload.data.remixPreset === 'selection';
const $c9c8b9d550aa1c05$var$ListenForSelectedContentRemixSubmit = ({ currentContentId: currentContentId, hasGenerationStarted: hasGenerationStarted, onAcceptSubmit: onAcceptSubmit, onDisarm: onDisarm, originContentIdRef: originContentIdRef })=>{
    const currentContentIdRef = (0, $cozmU.useRef)(currentContentId);
    currentContentIdRef.current = currentContentId;
    const hasGenerationStartedRef = (0, $cozmU.useRef)(hasGenerationStarted);
    hasGenerationStartedRef.current = hasGenerationStarted;
    const acceptedSubmitRef = (0, $cozmU.useRef)(false);
    const onAcceptSubmitRef = (0, $cozmU.useRef)(onAcceptSubmit);
    onAcceptSubmitRef.current = onAcceptSubmit;
    const onDisarmRef = (0, $cozmU.useRef)(onDisarm);
    onDisarmRef.current = onDisarm;
    const disarmIfIdle = (0, $cozmU.useCallback)(()=>{
        if (hasGenerationStartedRef.current || acceptedSubmitRef.current) return;
        onDisarmRef.current();
    }, []);
    (0, $hdBxM.useSubscribe)({
        topic: (0, $k1Pvg.Topics).ROVO_REMIX,
        consumeOnceKey: $c9c8b9d550aa1c05$var$RENDERER_SELECTION_CONSUME_ONCE_KEY
    }, (payload)=>{
        if (!$c9c8b9d550aa1c05$var$isRendererSelectionSubmit(payload) || payload.type !== 'submit-rovo-remix') return;
        const originContentId = originContentIdRef.current;
        if (originContentId && currentContentIdRef.current && originContentId !== currentContentIdRef.current) return;
        if (acceptedSubmitRef.current || hasGenerationStartedRef.current) return;
        acceptedSubmitRef.current = true;
        onAcceptSubmitRef.current({
            type: payload.data.remixOption,
            subType: payload.data.remixSubType,
            userPrompt: payload.data.userPrompt,
            conversationId: payload.data.conversationId
        }).then((result)=>{
            if (result.status === 'rejected') acceptedSubmitRef.current = false;
        }).catch(()=>{
            // Keep the listener retryable if an unexpected callback failure escapes.
            acceptedSubmitRef.current = false;
        });
    });
    (0, $hdBxM.useSubscribe)({
        topic: (0, $k1Pvg.Topics).AI_MATE
    }, (payload)=>{
        if (payload.type === 'chat-close') {
            disarmIfIdle();
            return;
        }
        if (payload.type === 'chat-new' && payload.data.resetActiveMenu) {
            disarmIfIdle();
            return;
        }
        if (payload.type !== 'open-rovo-remix-sidebar') return;
        if (payload.data.remixConsumer === 'renderer' && payload.data.remixPreset === 'selection') return;
        disarmIfIdle();
    });
    return null;
};
/**
 * Runs the Remix clean-up when the user closes the Rovo panel before choosing a Remix
 * option.
 *
 * Closing the Rovo panel sends no message that Confluence can listen for, so the only
 * way to notice it is to watch whether the panel is currently showing.
 *
 * The same click that arms the Remix flow also asks the panel to open, so there is a
 * short moment where the panel is not showing yet. Treating that moment as a close would
 * cancel the flow the instant it started, so a close is only acted on once the panel has
 * been seen showing at least once.
 */ const $c9c8b9d550aa1c05$var$CancelRemixWhenRovoPanelCloses = ({ onRovoPanelClosed: onRovoPanelClosed })=>{
    const { isConversationAssistantSidebarActive: isConversationAssistantSidebarActive, mode: mode } = (0, $1AJi3.useToggleConversationAssistant)();
    const isConversationAssistantOpen = isConversationAssistantSidebarActive || mode !== undefined;
    const hasSeenRovoPanelOpen = (0, $cozmU.useRef)(false);
    const onRovoPanelClosedRef = (0, $cozmU.useRef)(onRovoPanelClosed);
    onRovoPanelClosedRef.current = onRovoPanelClosed;
    (0, $cozmU.useEffect)(()=>{
        if (isConversationAssistantOpen) {
            hasSeenRovoPanelOpen.current = true;
            return;
        }
        if (!hasSeenRovoPanelOpen.current) return;
        onRovoPanelClosedRef.current();
    }, [
        isConversationAssistantOpen
    ]);
    return null;
};
const $c9c8b9d550aa1c05$var$RendererRemixCommandEffects = ({ isAdmittedRemixId: isAdmittedRemixId, onReady: onReady, onErrored: onErrored, onAborted: onAborted, onGenerationEnded: onGenerationEnded })=>{
    (0, $7GTyD.useRendererRemixCommands)(isAdmittedRemixId, {
        onReady: onReady,
        onErrored: onErrored,
        onAborted: onAborted,
        onGenerationEnded: onGenerationEnded
    });
    return null;
};
const $c9c8b9d550aa1c05$var$RendererRemixModal = ({ adfDocument: adfDocument, selectionContext: selectionContext, interactionSource: interactionSource, onClose: onClose, onFinalizeCommandSession: onFinalizeCommandSession, onStartThinking: onStartThinking, onStopThinking: onStopThinking, hiddenOptions: hiddenOptions, isEphemeralViewVisible: isEphemeralViewVisible, isRendererOverlayOpen: isRendererOverlayOpen, currentContentId: currentContentId, anchorRect: anchorRect, anchorElement: anchorElement, isThinking: isThinking, treatment: treatment })=>{
    const isMachineReadTreatment = treatment !== undefined;
    const machineLifecycle = treatment?.machineLifecycle;
    const parityDiagnostics = treatment?.parityDiagnostics;
    const [currentContentType] = (0, $ep3mz.useContentType)();
    const isRemixCancelled = (0, $cozmU.useRef)(false);
    const hasCommittedRemixCreateTerminal = (0, $cozmU.useRef)(false);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { trackGenerationFailed: trackGenerationFailed, trackGenerationStarted: trackGenerationStarted, trackGenerationStopped: trackGenerationStopped, trackGenerationSucceeded: trackGenerationSucceeded, trackRemixSubmitted: trackRemixSubmitted } = (0, $alDoy.useRemixGenerationAnalytics)();
    const unavailableSpaceOptions = (0, $hxqA6.useShouldHideDiagramRemixOption)();
    const mergedHiddenOptions = unavailableSpaceOptions.length > 0 ? [
        ...hiddenOptions,
        ...unavailableSpaceOptions
    ] : hiddenOptions;
    const openAIFCStagingModalRef = (0, $cozmU.useRef)(()=>{});
    const selectedSubTypeRef = (0, $cozmU.useRef)(undefined);
    const conversationIdRef = (0, $cozmU.useRef)(undefined);
    const remixOriginContentIdRef = (0, $cozmU.useRef)(undefined);
    const abortOriginRef = (0, $cozmU.useRef)();
    const [isLegacyActionReady, setIsLegacyActionReady] = (0, $cozmU.useState)(false);
    const [positionedAnchorRect, setPositionedAnchorRect] = (0, $cozmU.useState)(anchorRect);
    const [popupRepositionKey, setPopupRepositionKey] = (0, $cozmU.useState)(0);
    const restartExperiencesAfterRejectedStart = (0, $cozmU.useCallback)((rejectionReason)=>{
        const restartAttributes = {
            entryPoint: 'renderer',
            remixSource: 'rejectedRemixStart',
            product: 'confluence',
            rejectionReason: rejectionReason,
            ...interactionSource !== undefined ? {
                originalRemixSource: interactionSource
            } : {}
        };
        hasCommittedRemixCreateTerminal.current = false;
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            id: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: restartAttributes
        });
        (0, $kDDrf.startRemixCreateExperience)({
            experienceTracker: experienceTracker,
            attributes: restartAttributes
        });
    }, [
        experienceTracker,
        interactionSource
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (remixOriginContentIdRef.current === undefined) remixOriginContentIdRef.current = currentContentId;
    }, [
        currentContentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        setPositionedAnchorRect(anchorRect);
    }, [
        anchorRect
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!anchorElement) return;
        let animationFrameId;
        const updateAnchorPosition = ()=>{
            if (animationFrameId !== undefined) window.cancelAnimationFrame(animationFrameId);
            animationFrameId = window.requestAnimationFrame(()=>{
                // Keep the last known rect: the anchor can detach while the picker is opening.
                if (!anchorElement.isConnected) return;
                setPositionedAnchorRect(anchorElement.getBoundingClientRect());
                setPopupRepositionKey((key)=>key + 1);
            });
        };
        // `anchorRect` positions the initial render, so only follow on scroll/resize.
        const unbindScroll = (0, $cbY7C.bind)(window, {
            type: 'scroll',
            listener: updateAnchorPosition,
            options: {
                capture: true,
                passive: true
            }
        });
        const unbindResize = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: updateAnchorPosition
        });
        return ()=>{
            unbindScroll();
            unbindResize();
            if (animationFrameId !== undefined) window.cancelAnimationFrame(animationFrameId);
        };
    }, [
        anchorElement
    ]);
    const { dynamicUiType: dynamicUiType } = (0, $8akfd.useStagingAreaState)();
    const { openConversationAssistant: openConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const onPreviewOpened = (0, $cozmU.useCallback)(()=>machineLifecycle?.onPreviewOpened(), [
        machineLifecycle
    ]);
    const onPreviewDismissed = (0, $cozmU.useCallback)(()=>machineLifecycle?.onPreviewDismissed() ?? false, [
        machineLifecycle
    ]);
    const stopMachineThinking = (0, $cozmU.useCallback)(()=>machineLifecycle?.onStopThinking() ?? false, [
        machineLifecycle
    ]);
    const onRovoAborted = (0, $cozmU.useCallback)(()=>machineLifecycle?.onRovoAborted(), [
        machineLifecycle
    ]);
    const onErrorDismissed = (0, $cozmU.useCallback)(()=>machineLifecycle?.onErrorDismissed(), [
        machineLifecycle
    ]);
    const onSendRejected = (0, $cozmU.useCallback)(()=>machineLifecycle?.onSendRejected() ?? false, [
        machineLifecycle
    ]);
    const onNavigation = (0, $cozmU.useCallback)(()=>machineLifecycle?.onNavigation() ?? false, [
        machineLifecycle
    ]);
    const dismissRendererRemixUiAfterNavigation = (0, $cozmU.useCallback)(()=>{
        const reason = 'User navigated away before renderer remix preview opened';
        isRemixCancelled.current = true;
        if (isMachineReadTreatment) {
            abortOriginRef.current = 'navigation';
            if (onNavigation()) return;
        }
        onStopThinking();
        onClose();
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            reason: reason,
            attributes: {
                reason: reason
            }
        });
        (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
        (0, $irnO2.remixGeneratePreviewExperience).abort({
            metadata: {
                reason: reason
            }
        });
        if (!isMachineReadTreatment) onNavigation();
    }, [
        experienceTracker,
        isMachineReadTreatment,
        onClose,
        onNavigation,
        onStopThinking
    ]);
    const shouldOpenPreview = (0, $cozmU.useCallback)(()=>{
        if (isRemixCancelled.current && (0, $6mKj3.expVal)('cc_maui_polish_changes_batch_5', 'isEnabled', false)) return false;
        if (!(0, $iDrrr.fg)('cc-maui-phase-3')) return true;
        const originContentId = remixOriginContentIdRef.current;
        return !originContentId || !currentContentId || originContentId === currentContentId;
    }, [
        currentContentId
    ]);
    // Collapse the highlight overlay after the preview opens.
    const onAfterOpenPreview = (0, $cozmU.useCallback)(()=>{
        onClose({
            preservePreviewSession: true
        });
    }, [
        onClose
    ]);
    const { showProgressBar: showProgressBar, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, onActionReady: handlePreviewActionReady, resetCompletion: resetCompletion } = (0, $koSDQ.useRemixPreviewFlow)({
        entryPoint: 'renderer',
        experienceTracker: experienceTracker,
        dynamicUiType: dynamicUiType,
        selectedSubTypeRef: selectedSubTypeRef,
        openAIFCStagingModalRef: openAIFCStagingModalRef,
        isRemixCancelledRef: isRemixCancelled,
        conversationIdRef: conversationIdRef,
        shouldOpenPreview: shouldOpenPreview,
        onAfterOpenPreview: onAfterOpenPreview
    });
    const onActionReady = (0, $cozmU.useCallback)(()=>{
        if (!isRemixCancelled.current) trackGenerationSucceeded({
            conversationChannelId: conversationIdRef.current
        });
        handlePreviewActionReady();
    }, [
        handlePreviewActionReady,
        trackGenerationSucceeded
    ]);
    const onLegacyActionReady = (0, $cozmU.useCallback)(()=>{
        setIsLegacyActionReady(true);
        if (!isMachineReadTreatment) onActionReady();
    }, [
        isMachineReadTreatment,
        onActionReady
    ]);
    const handlePreviewDismissed = (0, $cozmU.useCallback)(()=>{
        if (isMachineReadTreatment) abortOriginRef.current = 'preview-dismissed';
        onPreviewDismissed();
    }, [
        isMachineReadTreatment,
        onPreviewDismissed
    ]);
    const { sendAIFCPrompt: sendAIFCPrompt, stopRemixing: stopRemixing, isRemixError: isRemixError, isRemixAborted: isRemixAborted, isRemixCancelled: wasRemixExplicitlyCancelled, remixStoreError: remixStoreError, remixConversationId: remixConversationId, openAIFCStagingModal: openAIFCStagingModal, closeAIFCStagingModal: closeAIFCStagingModal, resetRemixConversationId: resetRemixConversationId } = (0, $7eOZ4.useRemixToAIFC)({
        onActionReady: onLegacyActionReady,
        onPreviewOpened: onPreviewOpened,
        onPreviewDismissed: handlePreviewDismissed,
        trackRemixConversationById: true
    });
    openAIFCStagingModalRef.current = openAIFCStagingModal;
    const legacyRendererPhase = (0, $81UEG.deriveLegacyRendererRemixPhase)({
        isThinking: isThinking,
        isReady: isLegacyActionReady,
        isPreviewVisible: isEphemeralViewVisible,
        isError: isRemixError,
        isAborted: isRemixAborted,
        isCancelled: wasRemixExplicitlyCancelled
    });
    const machineRendererPhase = (0, $81UEG.deriveMachineRendererRemixPhase)(machineLifecycle?.phase);
    const rendererPhase = isMachineReadTreatment ? machineRendererPhase : legacyRendererPhase;
    (0, $cozmU.useEffect)(()=>{
        if (!parityDiagnostics) return;
        return parityDiagnostics.recordObservation({
            enabled: isMachineReadTreatment,
            remixId: machineLifecycle?.remixId,
            legacyPhase: legacyRendererPhase,
            machinePhase: machineRendererPhase
        });
    }, [
        isMachineReadTreatment,
        legacyRendererPhase,
        machineLifecycle?.remixId,
        machineRendererPhase,
        parityDiagnostics
    ]);
    // Preserve the legacy progress contract in control. Legacy `isThinking` remains true
    // through the normal ready interval, but unlike the normalized phase it does not revive
    // progress from stale completion state after a stopped flow reopens the picker.
    const isRendererRemixInProgress = isMachineReadTreatment ? rendererPhase === 'thinking' || rendererPhase === 'ready' : isThinking;
    const hasGenerationError = rendererPhase === 'error';
    const wasGenerationAborted = rendererPhase === 'aborted';
    const handleCommandReady = (0, $cozmU.useCallback)((command)=>{
        abortOriginRef.current = undefined;
        handlePreviewActionReady();
        if (!isRemixCancelled.current) trackGenerationSucceeded({
            conversationChannelId: command.conversationId
        });
    }, [
        handlePreviewActionReady,
        trackGenerationSucceeded
    ]);
    const handleCommandErrored = (0, $cozmU.useCallback)((command)=>{
        const commandStoreError = remixConversationId === command.conversationId ? remixStoreError : null;
        const errorMessage = commandStoreError?.content ?? 'Rovo agent error during remix';
        if (isEphemeralViewVisible) closeAIFCStagingModal();
        onClose({
            preserveCommandSession: true,
            preserveThinking: true
        });
        openConversationAssistant('sidebar');
        resetRemixConversationId();
        experienceTracker.fail({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            error: new Error(errorMessage),
            attributes: {
                errorType: commandStoreError?.errorType,
                traceId: commandStoreError?.traceId,
                errorStatusCode: commandStoreError?.status_code
            }
        });
        (0, $irnO2.remixGeneratePreviewExperience).failure({
            metadata: {
                errorType: commandStoreError?.errorType,
                traceId: commandStoreError?.traceId
            }
        });
        trackGenerationFailed({
            conversationChannelId: command.conversationId
        });
    }, [
        closeAIFCStagingModal,
        experienceTracker,
        isEphemeralViewVisible,
        onClose,
        openConversationAssistant,
        remixConversationId,
        remixStoreError,
        resetRemixConversationId,
        trackGenerationFailed
    ]);
    const handleCommandAborted = (0, $cozmU.useCallback)((command)=>{
        const abortOrigin = abortOriginRef.current;
        resetCompletion();
        if (abortOrigin === 'preview-dismissed' || abortOrigin === 'send-rejected') return;
        if (abortOrigin === 'navigation') {
            const reason = 'User navigated away before renderer remix preview opened';
            onClose({
                preserveCommandSession: true,
                preserveThinking: true
            });
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: reason,
                attributes: {
                    reason: reason
                }
            });
            (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
            (0, $irnO2.remixGeneratePreviewExperience).abort({
                metadata: {
                    reason: reason
                }
            });
            return;
        }
        const reason = abortOrigin === 'local-stop' ? 'User cancelled remix thinking' : 'User stopped from Rovo side chat';
        if (abortOrigin !== 'local-stop') {
            // The modal store can lag the terminal conversation snapshot, so closing is
            // intentionally idempotent even when render-time visibility is still false.
            if ((0, $6mKj3.expVal)('cc_maui_polish_changes_batch_5', 'isEnabled', false)) {
                isRemixCancelled.current = true;
                closeAIFCStagingModal();
            } else if (isEphemeralViewVisible) closeAIFCStagingModal();
        }
        const closesRendererUi = abortOrigin !== 'local-stop' || (0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop');
        if (closesRendererUi) onClose({
            preserveCommandSession: true,
            preserveThinking: true
        });
        try {
            if (abortOrigin === 'local-stop') {
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    reason: reason,
                    attributes: {
                        reason: reason
                    }
                });
                (0, $irnO2.remixGeneratePreviewExperience).abort({
                    metadata: {
                        reason: reason
                    }
                });
            }
            (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
            trackGenerationStopped({
                conversationChannelId: command.conversationId
            });
        } finally{
            if (!closesRendererUi) {
                const restartAttributes = {
                    entryPoint: 'renderer',
                    remixSource: 'cancelledRemixThinking',
                    originalRemixSource: 'selectionToolbar',
                    product: 'confluence'
                };
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    id: (0, $irnO2.ExperienceName).REMIX_START,
                    attributes: restartAttributes
                });
                (0, $kDDrf.startRemixCreateExperience)({
                    experienceTracker: experienceTracker,
                    attributes: restartAttributes
                });
            }
        }
    }, [
        closeAIFCStagingModal,
        experienceTracker,
        isEphemeralViewVisible,
        onClose,
        resetCompletion,
        trackGenerationStopped
    ]);
    const handleCommandGenerationEnded = (0, $cozmU.useCallback)((command)=>{
        const abortOrigin = abortOriginRef.current;
        const closesTreatmentSession = command.reason === 'error' || command.reason === 'aborted' && abortOrigin !== 'preview-dismissed' && abortOrigin !== 'send-rejected' && (abortOrigin !== 'local-stop' || (0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop'));
        if (abortOrigin !== 'preview-dismissed') onStopThinking({
            reopenModal: command.reason === 'ready' || abortOrigin === 'send-rejected' || abortOrigin === 'local-stop' && !(0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop')
        });
        if (command.reason === 'error') onErrorDismissed();
        else if (command.reason === 'aborted' && abortOrigin === undefined) onRovoAborted();
        if (closesTreatmentSession) onFinalizeCommandSession();
        abortOriginRef.current = undefined;
    }, [
        onErrorDismissed,
        onFinalizeCommandSession,
        onRovoAborted,
        onStopThinking
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('cc-maui-phase-3')) return;
        const originContentId = remixOriginContentIdRef.current;
        if (!originContentId || !currentContentId || originContentId === currentContentId) return;
        dismissRendererRemixUiAfterNavigation();
    }, [
        currentContentId,
        dismissRendererRemixUiAfterNavigation
    ]);
    // Abort experience on unmount (overlay closed without selecting an option).
    // Uses a ref so the cleanup always calls the latest tracker reference.
    const experienceTrackerRef = (0, $cozmU.useRef)(experienceTracker);
    experienceTrackerRef.current = experienceTracker;
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            experienceTrackerRef.current.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: 'User closed remix overlay',
                attributes: {
                    reason: 'User closed remix overlay'
                }
            });
            (0, $kDDrf.abortRemixCreateExperienceIfNotCommitted)(experienceTrackerRef.current, hasCommittedRemixCreateTerminal.current);
        };
    }, []);
    const onRemixFlowActiveChange = (0, $cozmU.useCallback)((active)=>{
        if (active) {
            isRemixCancelled.current = false;
            abortOriginRef.current = undefined;
            // Clear stale completion state from any previous flow.
            resetCompletion();
            setIsLegacyActionReady(false);
            onStartThinking();
        } else {
            isRemixCancelled.current = true;
            // A stopped flow can already have reached the completed-progress interval.
            // Clear it before reopening so control does not render a stale ready picker.
            resetCompletion();
            setIsLegacyActionReady(false);
            if (isMachineReadTreatment) {
                abortOriginRef.current = 'local-stop';
                remixOriginContentIdRef.current = undefined;
                let didApplyTerminalEvent = false;
                try {
                    stopRemixing();
                    parityDiagnostics?.recordLegacyTerminal(machineLifecycle?.remixId, 'aborted');
                } finally{
                    didApplyTerminalEvent = stopMachineThinking();
                }
                if (!didApplyTerminalEvent) {
                    const reason = 'User cancelled remix thinking';
                    if ((0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop')) onClose();
                    else onStopThinking({
                        reopenModal: true
                    });
                    try {
                        experienceTracker.abort({
                            name: (0, $irnO2.ExperienceName).REMIX_START,
                            reason: reason,
                            attributes: {
                                reason: reason
                            }
                        });
                        (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
                        (0, $irnO2.remixGeneratePreviewExperience).abort({
                            metadata: {
                                reason: reason
                            }
                        });
                        trackGenerationStopped({
                            conversationChannelId: conversationIdRef.current
                        });
                    } finally{
                        if (!(0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop')) {
                            const restartAttributes = {
                                entryPoint: 'renderer',
                                remixSource: 'cancelledRemixThinking',
                                originalRemixSource: 'selectionToolbar',
                                product: 'confluence'
                            };
                            experienceTracker.start({
                                name: (0, $irnO2.ExperienceName).REMIX_START,
                                id: (0, $irnO2.ExperienceName).REMIX_START,
                                attributes: restartAttributes
                            });
                            (0, $kDDrf.startRemixCreateExperience)({
                                experienceTracker: experienceTracker,
                                attributes: restartAttributes
                            });
                        }
                    }
                }
                return;
            }
            // Abort the current experience before stopping
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: 'User cancelled remix thinking',
                attributes: {
                    reason: 'User cancelled remix thinking'
                }
            });
            (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, 'User cancelled remix thinking');
            (0, $irnO2.remixGeneratePreviewExperience).abort({
                metadata: {
                    reason: 'User cancelled remix thinking'
                }
            });
            trackGenerationStopped();
            remixOriginContentIdRef.current = undefined;
            try {
                stopRemixing();
                parityDiagnostics?.recordLegacyTerminal(machineLifecycle?.remixId, 'aborted');
            } finally{
                stopMachineThinking();
            }
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop')) onClose();
            else {
                // Start a new experience for the reopened overlay
                const restartAttributes = {
                    entryPoint: 'renderer',
                    remixSource: 'cancelledRemixThinking',
                    originalRemixSource: 'selectionToolbar',
                    product: 'confluence'
                };
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    id: (0, $irnO2.ExperienceName).REMIX_START,
                    attributes: restartAttributes
                });
                (0, $kDDrf.startRemixCreateExperience)({
                    experienceTracker: experienceTracker,
                    attributes: restartAttributes
                });
                onStopThinking({
                    reopenModal: true
                });
            }
        }
    }, [
        onStartThinking,
        stopRemixing,
        stopMachineThinking,
        onClose,
        onStopThinking,
        experienceTracker,
        resetCompletion,
        parityDiagnostics,
        machineLifecycle?.remixId,
        trackGenerationStopped,
        isMachineReadTreatment
    ]);
    // Fail experience and clean up thinking UI when Rovo encounters an error
    const prevHasGenerationError = (0, $cozmU.useRef)(hasGenerationError);
    (0, $cozmU.useEffect)(()=>{
        if (!isMachineReadTreatment && !prevHasGenerationError.current && hasGenerationError && !isRemixCancelled.current) {
            const errorMessage = remixStoreError?.content ?? 'Rovo agent error during remix';
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                error: new Error(errorMessage),
                attributes: {
                    errorType: remixStoreError?.errorType,
                    traceId: remixStoreError?.traceId,
                    errorStatusCode: remixStoreError?.status_code
                }
            });
            (0, $irnO2.remixGeneratePreviewExperience).failure({
                metadata: {
                    errorType: remixStoreError?.errorType,
                    traceId: remixStoreError?.traceId
                }
            });
            trackGenerationFailed({
                conversationChannelId: conversationIdRef.current
            });
            onStopThinking({
                reopenModal: true
            });
        }
        prevHasGenerationError.current = hasGenerationError;
    }, [
        hasGenerationError,
        isMachineReadTreatment,
        remixStoreError,
        onStopThinking,
        experienceTracker,
        trackGenerationFailed
    ]);
    // When an error occurs during remix, close the thinking bar and ephemeral
    // preview, then open the Rovo chat sidebar so the user can see the error.
    (0, $cozmU.useEffect)(()=>{
        if (!isMachineReadTreatment && !isRemixCancelled.current && hasGenerationError) {
            // Close the ephemeral preview (staging modal) if it is open
            if (isEphemeralViewVisible) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- terminal cleanup intentionally settles each existing product store
            closeAIFCStagingModal();
            // Close the thinking bar and dismiss the remix UI
            onStopThinking();
            onClose();
            // Open the Rovo chat sidebar to display the error information.
            // `openConversationAssistant` is idempotent (no-op if already
            // open), so it is safe to call on every render where
            // the selected phase is `error` — no infinite toggle loop.
            openConversationAssistant('sidebar');
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- terminal cleanup intentionally settles each existing product store
            resetRemixConversationId();
            onErrorDismissed();
        }
    }, [
        hasGenerationError,
        isMachineReadTreatment,
        isEphemeralViewVisible,
        closeAIFCStagingModal,
        onStopThinking,
        onClose,
        openConversationAssistant,
        resetRemixConversationId,
        onErrorDismissed
    ]);
    // Dismiss the thinking bar and clear the selection highlight when the user
    // stops the remix from the Rovo side chat.
    (0, $cozmU.useEffect)(()=>{
        if (!isMachineReadTreatment && wasGenerationAborted && !isRemixCancelled.current) {
            const reason = 'User stopped from Rovo side chat';
            if ((0, $6mKj3.expVal)('cc_maui_polish_changes_batch_5', 'isEnabled', false)) {
                isRemixCancelled.current = true;
                resetCompletion();
                // The modal store visibility can lag behind action readiness for
                // non-streaming remix types. Closing is idempotent, so do it even
                // when the render-time visibility snapshot is still false.
                // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- terminal cleanup intentionally settles each existing product store
                closeAIFCStagingModal();
            } else if (isEphemeralViewVisible) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- terminal cleanup intentionally settles each existing product store
            closeAIFCStagingModal();
            (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
            trackGenerationStopped({
                conversationChannelId: conversationIdRef.current
            });
            onStopThinking();
            onClose();
            onRovoAborted();
        }
    }, [
        wasGenerationAborted,
        isMachineReadTreatment,
        isEphemeralViewVisible,
        closeAIFCStagingModal,
        onStopThinking,
        onClose,
        experienceTracker,
        onRovoAborted,
        resetCompletion,
        trackGenerationStopped
    ]);
    const handleOptionSelect = (0, $cozmU.useCallback)(async ({ type: type, subType: subType, userPrompt: userPrompt, conversationId: conversationId })=>{
        // Only a submission from the Rovo sidebar carries a conversationId, and the Rovo
        // sidebar is only shown to the variant2 cohort. Its `userPrompt` is already the
        // complete sentence shown in the chat input, so passing that sentence as
        // `promptText` stops `sendAIFCPrompt` from writing a second copy of the same
        // sentence and joining the two together. Checking the cohort as well as the
        // conversationId guarantees that anyone outside the experiment keeps the original
        // behaviour, even if some future caller starts supplying a conversationId.
        const isRovoChatSubmission = conversationId !== undefined && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2');
        remixOriginContentIdRef.current = remixOriginContentIdRef.current ?? currentContentId;
        selectedSubTypeRef.current = subType;
        const dynamicUiSource = $c9c8b9d550aa1c05$var$constructDynamicUiSource(adfDocument, selectionContext, (0, $3OD5k.resolveRemixDynamicUiContentType)(currentContentType));
        let authoritativeConversationId = conversationId;
        let cancellationSessionId;
        if (machineLifecycle) {
            const admission = machineLifecycle.startFlow({
                conversationId: conversationId,
                dynamicUiType: type,
                dynamicUiSubtype: subType,
                source: interactionSource
            });
            if (!admission.admitted) {
                if (admission.reason !== 'active-flow') {
                    const admissionError = new Error(`Renderer Remix machine admission was rejected: ${admission.reason}`);
                    experienceTracker.fail({
                        name: (0, $irnO2.ExperienceName).REMIX_START,
                        error: admissionError,
                        attributes: {
                            reason: admissionError.message,
                            rejectionReason: admission.reason
                        }
                    });
                    (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, admissionError.message);
                    restartExperiencesAfterRejectedStart(admission.reason);
                }
                onStopThinking({
                    reopenModal: true
                });
                return {
                    status: 'rejected',
                    reason: 'admission-rejected'
                };
            }
            authoritativeConversationId = admission.conversationId;
            cancellationSessionId = admission.cancellationSessionId;
        }
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                remixType: type,
                remixSubtype: subType,
                includesFreegenPrompt: !!userPrompt
            }
        });
        (0, $irnO2.remixGeneratePreviewExperience).start();
        (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).SUBMIT);
        (0, $irnO2.remixGeneratePreviewExperience).addMetadata({
            product: 'confluence',
            interactionSource: interactionSource,
            entryPoint: 'renderer',
            remixType: type,
            remixSubtype: subType,
            includesFreegenPrompt: !!userPrompt,
            ...type === 'infographic' ? {
                isConfluenceInfographicsTwoStageEnabled: (0, $iDrrr.fg)('confluence-infographics-two-stage')
            } : {}
        });
        const generationAnalyticsAttributes = {
            contentId: currentContentId,
            ...conversationId && {
                conversationChannelId: conversationId
            },
            entryPoint: 'renderer',
            includesFreegenPrompt: !!userPrompt,
            product: 'confluence',
            remixSource: interactionSource,
            remixSubtype: subType,
            remixType: type
        };
        trackRemixSubmitted(generationAnalyticsAttributes);
        trackGenerationStarted(generationAnalyticsAttributes);
        let conversationChannelId;
        try {
            conversationChannelId = await sendAIFCPrompt({
                userPrompt: isRovoChatSubmission ? undefined : userPrompt,
                promptText: isRovoChatSubmission ? userPrompt : undefined,
                dynamicUiType: type,
                dynamicUiSubtype: subType,
                dynamicUiSource: dynamicUiSource,
                interactionSource: interactionSource,
                ...authoritativeConversationId !== undefined ? {
                    conversationId: authoritativeConversationId
                } : {},
                ...cancellationSessionId !== undefined ? {
                    remixCancellationSessionId: cancellationSessionId
                } : {}
            });
        } catch (error) {
            if (isMachineReadTreatment) abortOriginRef.current = 'send-rejected';
            const didApplyTerminalEvent = onSendRejected();
            if (isMachineReadTreatment && !didApplyTerminalEvent) onStopThinking({
                reopenModal: true
            });
            if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2')) $c9c8b9d550aa1c05$var$publishRendererRemixHandoffFailed();
            const sendError = error instanceof Error ? error : new Error('Failed to send renderer Remix prompt');
            const reason = 'Failed to send renderer Remix prompt';
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                error: sendError,
                attributes: {
                    reason: reason,
                    rejectionReason: 'send-failed'
                }
            });
            (0, $irnO2.remixGeneratePreviewExperience).failure({
                metadata: {
                    reason: reason
                }
            });
            trackGenerationFailed();
            (0, $kDDrf.failRemixCreateExperience)(experienceTracker, sendError, {
                reason: reason,
                rejectionReason: 'send-failed'
            });
            restartExperiencesAfterRejectedStart('send-failed');
            if (!isMachineReadTreatment) onStopThinking({
                reopenModal: true
            });
            return {
                status: 'rejected',
                reason: 'send-failed'
            };
        }
        // Stash the conversationId so `useRemixPreviewFlow` can include it as
        // `conversationChannelId` on the REMIX_RENDERS_IN_MODAL start attributes
        // once `onActionReady` fires.
        conversationIdRef.current = conversationChannelId;
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                conversationChannelId: conversationChannelId
            }
        });
        hasCommittedRemixCreateTerminal.current = true;
        (0, $kDDrf.trackRemixCreateOptionSelected)({
            experienceTracker: experienceTracker,
            conversationId: conversationChannelId,
            remixType: type,
            remixSubtype: subType,
            includesFreegenPrompt: !!userPrompt
        });
        return {
            status: 'started'
        };
    }, [
        sendAIFCPrompt,
        adfDocument,
        selectionContext,
        currentContentType,
        interactionSource,
        experienceTracker,
        currentContentId,
        isMachineReadTreatment,
        machineLifecycle,
        onSendRejected,
        onStopThinking,
        restartExperiencesAfterRejectedStart,
        trackGenerationFailed,
        trackGenerationStarted,
        trackRemixSubmitted
    ]);
    const acceptRovoRemixSubmit = (0, $cozmU.useCallback)((params)=>{
        onRemixFlowActiveChange(true);
        return handleOptionSelect(params);
    }, [
        handleOptionSelect,
        onRemixFlowActiveChange
    ]);
    const shouldShowOriginalRemixPopUpWindow = isRendererRemixInProgress || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, machineLifecycle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixCommandEffects, {
        isAdmittedRemixId: machineLifecycle.isAdmittedRemixId,
        onReady: handleCommandReady,
        onErrored: handleCommandErrored,
        onAborted: handleCommandAborted,
        onGenerationEnded: handleCommandGenerationEnded
    }), isRendererOverlayOpen && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$ListenForSelectedContentRemixSubmit, {
        currentContentId: currentContentId,
        hasGenerationStarted: isRendererRemixInProgress,
        onAcceptSubmit: acceptRovoRemixSubmit,
        onDisarm: onClose,
        originContentIdRef: remixOriginContentIdRef
    }), isRendererOverlayOpen && shouldShowOriginalRemixPopUpWindow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
        onClose: ()=>onClose(),
        hiddenOptions: mergedHiddenOptions,
        onOptionSelect: handleOptionSelect,
        onRemixFlowActiveChange: onRemixFlowActiveChange,
        isEphemeralViewVisible: isEphemeralViewVisible,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        // Classic view page: center the fixed thinking bar over the rendered content area.
        // Safe here because the view page has a stable layout (unlike the editor, whose
        // reflows would make the one-shot content measurement drift).
        shouldMeasureContentBounds: true,
        // The view floating toolbar provides a live element that is remeasured as it moves.
        // Snapshot-only renderer entries, such as the nudge, still close on external scroll.
        anchorRect: positionedAnchorRect,
        popupRepositionKey: popupRepositionKey,
        shouldCloseOnScroll: !anchorElement,
        isThinking: isMachineReadTreatment ? isRendererRemixInProgress : isRendererRemixInProgress && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2') ? true : undefined,
        // The nudge icon sits at the top-right of a block; flying the popup out to the right
        // would frequently clip against the viewport edge, so it opens to the left instead.
        popupPlacement: interactionSource === 'remixModalFromViewPageNudge' ? 'bottom-end' : 'bottom-start',
        // Match the view selection toolbar's ellipsis DropdownMenu default offset.
        popupOffset: [
            0,
            8
        ]
    }));
};
const $c9c8b9d550aa1c05$var$RendererRemixContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    openRemixModal: ()=>{},
    closeRemixModal: ()=>{},
    clearRemixHighlight: ()=>{},
    isRemixDisabled: false,
    isRemixing: false,
    isRemixInProgress: false,
    isRemixBlockingNewTargets: false,
    isAnyRemixing: false,
    remixInteractionSource: undefined,
    registerOnModalClose: ()=>()=>{}
});
const $c9c8b9d550aa1c05$export$c881c5d3c5870780 = ()=>{
    return (0, $cozmU.useContext)($c9c8b9d550aa1c05$var$RendererRemixContext);
};
const $c9c8b9d550aa1c05$var$RendererRemixContainerImpl = ({ children: children, contentId: contentId, treatment: treatment })=>{
    const isRemixAvailable = (0, $dnbZ2.useIsRemixAvailable)();
    // Prefetch only attachment permission. Existing space-type checks remain modal-local.
    const hiddenOptions = (0, $hxqA6.useShouldHideAttachmentRemixOptions)({
        enabled: isRemixAvailable
    });
    const isMachineReadTreatment = treatment !== undefined;
    const isAnyRemixing = treatment?.isAnyRemixing ?? false;
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [adfDocument, setAdfDocument] = (0, $cozmU.useState)(null);
    const [selectionContext, setSelectionContext] = (0, $cozmU.useState)(null);
    const [isThinking, setIsThinking] = (0, $cozmU.useState)(false);
    const [anchorRect, setAnchorRect] = (0, $cozmU.useState)(undefined);
    const [anchorElement, setAnchorElement] = (0, $cozmU.useState)(undefined);
    const [remixInteractionSource, setRemixInteractionSource] = (0, $cozmU.useState)(undefined);
    const { startHighlight: startHighlight, clearHighlight: clearHighlight } = (0, $jNS1v.useRendererRemixHighlight)();
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const onModalCloseCallbacks = (0, $cozmU.useRef)(new Set());
    const registerOnModalClose = (0, $cozmU.useCallback)((callback)=>{
        onModalCloseCallbacks.current.add(callback);
        return ()=>{
            onModalCloseCallbacks.current.delete(callback);
        };
    }, []);
    const clearModalSession = (0, $cozmU.useCallback)(()=>{
        setAdfDocument(null);
        setSelectionContext(null);
        setRemixInteractionSource(undefined);
        setAnchorRect(undefined);
        setAnchorElement(undefined);
    }, []);
    const prevShowSmartCreationModal = (0, $cozmU.useRef)(showSmartCreationModal);
    (0, $cozmU.useEffect)(()=>{
        if (prevShowSmartCreationModal.current && !showSmartCreationModal) {
            clearHighlight();
            // Smart Creation owns the preview and can close outside this container's closeModal path.
            // Release the renderer session when that external modal-store transition completes.
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
            clearModalSession();
        }
        prevShowSmartCreationModal.current = showSmartCreationModal;
    }, [
        showSmartCreationModal,
        clearHighlight,
        clearModalSession
    ]);
    const openModal = (0, $cozmU.useCallback)((newAdfDocument, selection, interactionSource, newAnchorRect, newAnchorElement)=>{
        // Record the Remix menu experiment exposure here. This is the one point that the
        // selection toolbar and the nudge both call for every cohort, and it is where the
        // cohort decides which Remix picker the person is about to see. Recording it further
        // downstream, once each cohort's own picker had appeared, undercounted the variant2
        // group, because their picker only appears after the Rovo side panel and two lazily
        // loaded chunks have all arrived.
        (0, $6mKj3.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
        (0, $6mKj3.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        if (isMachineReadTreatment) // Only treatment admits a machine flow from this modal. The background-phase watcher
        // host may not have loaded yet on a fresh page, so start its fetch now for that flow.
        (0, $iMLPM.preloadRemixWatcherHost)();
        setAdfDocument(newAdfDocument);
        startHighlight();
        setSelectionContext(selection);
        setRemixInteractionSource(interactionSource);
        setAnchorRect(newAnchorRect);
        setAnchorElement(newAnchorElement);
        setIsModalOpen(true);
    }, [
        isMachineReadTreatment,
        startHighlight
    ]);
    const closeModal = (0, $cozmU.useCallback)((options)=>{
        if (!options?.preservePreviewSession) clearHighlight();
        onModalCloseCallbacks.current.forEach((cb)=>cb());
        setIsModalOpen(false);
        if (!options?.preserveThinking) setIsThinking(false);
        // Treatment keeps the phase-consuming modal subtree mounted while the Smart Creation
        // preview is open, so watcher terminal phases can drive renderer UX before teardown.
        if (!options?.preservePreviewSession && !options?.preserveCommandSession || !isMachineReadTreatment) clearModalSession();
    }, [
        clearHighlight,
        clearModalSession,
        isMachineReadTreatment
    ]);
    const onStartThinking = (0, $cozmU.useCallback)(()=>{
        setIsThinking(true);
        setIsModalOpen(false);
    }, []);
    const onStopThinking = (0, $cozmU.useCallback)((options)=>{
        setIsThinking(false);
        if (options?.reopenModal) setIsModalOpen(true);
    }, []);
    const rendererPhase = treatment ? (0, $81UEG.deriveMachineRendererRemixPhase)(treatment.machineLifecycle.phase) : (0, $81UEG.deriveLegacyRendererRemixPhase)({
        isThinking: isThinking,
        isReady: false,
        isPreviewVisible: showSmartCreationModal,
        isError: false,
        isAborted: false,
        isCancelled: false
    });
    const isRemixInProgress = rendererPhase === 'thinking' || rendererPhase === 'ready';
    const isRemixCommitted = showSmartCreationModal || isRemixInProgress || rendererPhase === 'previewing' || rendererPhase === 'submitting';
    // Variant 2 alone keeps its local picker active while the user chooses a target. Every
    // other cohort, and every committed flow, keeps the existing single-target policy.
    const context = (0, $cozmU.useMemo)(()=>{
        const isRemixing = isModalOpen || isRemixCommitted;
        const isRemixBlockingNewTargets = isAnyRemixing || isRemixing && (isRemixCommitted || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2'));
        return {
            openRemixModal: openModal,
            closeRemixModal: closeModal,
            clearRemixHighlight: clearHighlight,
            isRemixDisabled: false,
            isRemixing: // These values describe how far along a Remix is, and they deliberately differ from
            // one another:
            //
            // - `isRemixing` becomes true as soon as any Remix flow opens, which includes the time
            //   the person spends looking at the list of Remix choices before picking one.
            // - `isRemixInProgress` is true only while content is being generated or has just
            //   finished being generated.
            // - `isRemixBlockingNewTargets` is true when another entry point must not replace the
            //   currently targeted content.
            isRemixing,
            isRemixInProgress: isRemixInProgress,
            isRemixBlockingNewTargets: isRemixBlockingNewTargets,
            isAnyRemixing: isAnyRemixing,
            remixInteractionSource: remixInteractionSource,
            registerOnModalClose: registerOnModalClose
        };
    }, [
        openModal,
        closeModal,
        clearHighlight,
        isModalOpen,
        isRemixCommitted,
        isRemixInProgress,
        isAnyRemixing,
        remixInteractionSource,
        registerOnModalClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContext.Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fj6ez.RendererRemixHighlightStyles), null), children, isModalOpen && !isThinking && !isRemixCommitted && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$CancelRemixWhenRovoPanelCloses, {
        onRovoPanelClosed: closeModal
    }), (isModalOpen || isThinking || isMachineReadTreatment) && adfDocument && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixModal, {
        adfDocument: adfDocument,
        hiddenOptions: hiddenOptions,
        selectionContext: selectionContext,
        interactionSource: remixInteractionSource,
        onClose: closeModal,
        onFinalizeCommandSession: clearModalSession,
        onStartThinking: onStartThinking,
        onStopThinking: onStopThinking,
        isEphemeralViewVisible: showSmartCreationModal,
        isRendererOverlayOpen: isModalOpen || isThinking,
        currentContentId: contentId,
        anchorRect: anchorRect,
        anchorElement: anchorElement,
        isThinking: isThinking,
        treatment: treatment
    })));
};
const $c9c8b9d550aa1c05$var$RendererRemixTreatmentHost = ({ children: children, contentId: contentId })=>{
    // CCCEMAU-3500 parity diagnostics - remove with the Remix state management refactor.
    const parityDiagnostics = (0, $8L2yq.useRendererRemixParityDiagnostics)();
    const machineLifecycle = (0, $etOkO.useRendererRemixMachineLifecycle)({
        onLifecycleBoundary: parityDiagnostics.recordLifecycleBoundary
    });
    const isAnyRemixing = (0, $gRoSG.useIsAnyRemixing)();
    const treatment = (0, $cozmU.useMemo)(()=>({
            machineLifecycle: machineLifecycle,
            parityDiagnostics: parityDiagnostics,
            isAnyRemixing: isAnyRemixing
        }), [
        machineLifecycle,
        parityDiagnostics,
        isAnyRemixing
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContainerImpl, {
        contentId: contentId,
        treatment: treatment
    }, children);
};
const $c9c8b9d550aa1c05$var$RendererRemixTreatmentDecision = ({ children: children, contentId: contentId, isRemixAvailable: isRemixAvailable, isLifecycleAdapterAvailable: isLifecycleAdapterAvailable })=>{
    // This decision is intentionally fixed for the mounted renderer surface. The regular experiment
    // evaluation is therefore the first Statsig exposure for both control and treatment, while every
    // earlier eligibility sentinel short-circuits without evaluating the surface experiment.
    const [isMachineReadTreatment] = (0, $cozmU.useState)(()=>isRemixAvailable && isLifecycleAdapterAvailable && (0, $iDrrr.fg)('remix_state_rearchitecture_enabled') && (0, $6mKj3.isExperimentEnabled)('remix_state_rearchitecture_renderer'));
    if (isMachineReadTreatment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixTreatmentHost, {
        contentId: contentId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContainerImpl, {
        contentId: contentId
    }, children);
};
const $c9c8b9d550aa1c05$var$RendererRemixContainerOwner = ({ children: children, contentId: contentId, isLifecycleAdapterAvailable: isLifecycleAdapterAvailable })=>{
    const isRemixAvailable = (0, $dnbZ2.useIsRemixAvailable)();
    // Availability and adapter capability are both host-boundaries. If either changes, remounting
    // reevaluates eligibility before any treatment hook is mounted rather than pinning a stale control
    // decision in the existing renderer session.
    const eligibilityKey = `${isRemixAvailable}:${isLifecycleAdapterAvailable}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixTreatmentDecision, {
        key: eligibilityKey,
        contentId: contentId,
        isRemixAvailable: isRemixAvailable,
        isLifecycleAdapterAvailable: isLifecycleAdapterAvailable
    }, children);
};
const $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue = (reason)=>({
        openRemixModal: ()=>{},
        closeRemixModal: ()=>{},
        clearRemixHighlight: ()=>{},
        isRemixDisabled: true,
        isRemixing: false,
        isRemixInProgress: false,
        isRemixBlockingNewTargets: false,
        isAnyRemixing: false,
        remixInteractionSource: undefined,
        remixDisabledReason: reason,
        registerOnModalClose: ()=>()=>{}
    });
const $c9c8b9d550aa1c05$var$disabledRemixContextValue = $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue();
const $c9c8b9d550aa1c05$export$62131e16a1db8364 = ({ children: children, contentId: contentId, isDisabled: isDisabled, remixDisabledReason: remixDisabledReason, isLifecycleAdapterAvailable: isLifecycleAdapterAvailable = false })=>{
    if (isDisabled) {
        const contextValue = remixDisabledReason ? $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue(remixDisabledReason) : $c9c8b9d550aa1c05$var$disabledRemixContextValue;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContext.Provider, {
            value: contextValue
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContainerOwner, {
        contentId: contentId,
        isLifecycleAdapterAvailable: isLifecycleAdapterAvailable
    }, children);
};
module.exports["useRendererRemixContext"] = $c9c8b9d550aa1c05$export$c881c5d3c5870780;
module.exports["RendererRemixContainer"] = $c9c8b9d550aa1c05$export$62131e16a1db8364;

});

parcelRegister("81UEG", function(module, exports) {
const $9dc19d5e68a65b89$export$63336757f28ec02f = ({ isThinking: isThinking, isReady: isReady, isPreviewVisible: isPreviewVisible, isError: isError, isAborted: isAborted, isCancelled: isCancelled })=>{
    if (isError) return 'error';
    if (isAborted || isCancelled) return 'aborted';
    if (isPreviewVisible) return 'previewing';
    if (isReady) return 'ready';
    if (isThinking) return 'thinking';
    return 'inactive';
};
const $9dc19d5e68a65b89$var$machineToRendererPhase = {
    thinking: 'thinking',
    ready: 'ready',
    previewing: 'previewing',
    inserting: 'submitting',
    error: 'error',
    aborted: 'aborted'
};
const $9dc19d5e68a65b89$export$b1a7146262519ea1 = (phase)=>phase === undefined ? 'inactive' : $9dc19d5e68a65b89$var$machineToRendererPhase[phase];
module.exports["deriveLegacyRendererRemixPhase"] = $9dc19d5e68a65b89$export$63336757f28ec02f;
module.exports["deriveMachineRendererRemixPhase"] = $9dc19d5e68a65b89$export$b1a7146262519ea1;

});

parcelRegister("fj6ez", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");

function $738409fb11353f61$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $738409fb11353f61$var$rendererHighlightStyles = {
    name: "18r8tnl",
    styles: "::highlight(remix-thinking-renderer){background-color:var(--ds-background-accent-purple-subtler, #EED7FC);text-decoration:underline;text-decoration-style:dotted;text-decoration-thickness:var(--ds-space-025, 2px);text-decoration-color:var(--ds-border-accent-purple, #AF59E1);text-decoration-skip-ink:none;}"
};
const $738409fb11353f61$export$533b8d7a5499bf49 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        styles: $738409fb11353f61$var$rendererHighlightStyles
    }));
};
module.exports["RendererRemixHighlightStyles"] = $738409fb11353f61$export$533b8d7a5499bf49;

});

parcelRegister("dnbZ2", function(module, exports) {

var $3ricL = parcelRequire("3ricL");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $c4wtI = parcelRequire("c4wtI");

const $2a69d40b2e0abea7$export$4739f60b2e0ffe71 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    if ((0, $6mKj3.isExperimentEnabled)('cc-maui-feature-encoding-sdk-exp')) {
        if (!(0, $3ricL.isFeatureEnabled)('confluence', 'confluence-remix')) return false;
    }
    return isRovoLLMEnabled && !(0, $c4wtI.isRemixOptedOut)() && (0, $6mKj3.isExperimentEnabled)('cc-maui-experiment');
};
module.exports["useIsRemixAvailable"] = $2a69d40b2e0abea7$export$4739f60b2e0ffe71;

});

parcelRegister("c4wtI", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $5dba2f21328d6f88$export$18f828f11aef2dd3 = ()=>(0, $9wGTI.fg)('cc-maui-opted-out');
module.exports["isRemixOptedOut"] = $5dba2f21328d6f88$export$18f828f11aef2dd3;

});

parcelRegister("7GTyD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lEf8v = parcelRequire("lEf8v");

const $7320d3edb50fb9c8$export$d4909a6f4c87ce20 = (isAdmittedRemixId, { onReady: onReady, onErrored: onErrored, onAborted: onAborted, onGenerationEnded: onGenerationEnded })=>{
    const handledRef = (0, $cozmU.useRef)({
        remixId: undefined,
        commands: new Set()
    });
    (0, $lEf8v.useRemixCommands)((command)=>{
        if (!isAdmittedRemixId(command.remixId)) return;
        if (handledRef.current.remixId !== command.remixId) handledRef.current = {
            remixId: command.remixId,
            commands: new Set()
        };
        let claim;
        switch(command.type){
            case 'RemixReady':
            case 'RemixErrored':
            case 'RemixAborted':
                claim = command.type;
                break;
            case 'RemixGenerationEnded':
                claim = `${command.type}:${command.reason}`;
                break;
            default:
                return;
        }
        if (handledRef.current.commands.has(claim)) return;
        handledRef.current.commands.add(claim);
        switch(command.type){
            case 'RemixReady':
                onReady(command);
                break;
            case 'RemixErrored':
                onErrored(command);
                break;
            case 'RemixAborted':
                onAborted(command);
                break;
            case 'RemixGenerationEnded':
                onGenerationEnded(command);
                break;
        }
    });
};
module.exports["useRendererRemixCommands"] = $7320d3edb50fb9c8$export$d4909a6f4c87ce20;

});

parcelRegister("jNS1v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5ae98e04c533e5e9$var$HIGHLIGHT_NAME = 'remix-thinking-renderer';
const $5ae98e04c533e5e9$export$443e8aeb4c392a84 = ()=>{
    const savedRangeRef = (0, $cozmU.useRef)(null);
    const [isHighlighting, setIsHighlighting] = (0, $cozmU.useState)(false);
    const clearHighlight = (0, $cozmU.useCallback)(()=>{
        if (typeof Highlight !== 'undefined' && 'highlights' in CSS) CSS.highlights.delete($5ae98e04c533e5e9$var$HIGHLIGHT_NAME);
        savedRangeRef.current = null;
        setIsHighlighting(false);
    }, []);
    const startHighlight = (0, $cozmU.useCallback)(()=>{
        // Drop any highlight left over from an earlier Remix before looking for the new one.
        // Without this, starting a Remix of a different piece of content while there is no live
        // text selection would leave the earlier content highlighted, pointing at content that is
        // no longer the one being Remixed.
        clearHighlight();
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const sel = document.getSelection();
        if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return;
        const range = sel.getRangeAt(0).cloneRange();
        savedRangeRef.current = range;
        if (typeof Highlight !== 'undefined' && 'highlights' in CSS) {
            const highlight = new Highlight(range);
            CSS.highlights.set($5ae98e04c533e5e9$var$HIGHLIGHT_NAME, highlight);
            sel.removeAllRanges();
            setIsHighlighting(true);
        }
    }, [
        clearHighlight
    ]);
    return {
        startHighlight: startHighlight,
        clearHighlight: clearHighlight,
        isHighlighting: isHighlighting,
        savedRange: savedRangeRef
    };
};
module.exports["useRendererRemixHighlight"] = $5ae98e04c533e5e9$export$443e8aeb4c392a84;

});

parcelRegister("etOkO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9HkI0 = parcelRequire("9HkI0");


var $9DHhW = parcelRequire("9DHhW");


var $hwgBi = parcelRequire("hwgBi");


var $bWlOZ = parcelRequire("bWlOZ");

var $gRoSG = parcelRequire("gRoSG");

const $e7504183f26ea064$var$readMachineTerminalPhase = (remixId)=>{
    const phase = (0, $bWlOZ.getRemixMachine)(remixId)?.state();
    return phase === 'aborted' || phase === 'error' ? phase : undefined;
};
const $e7504183f26ea064$export$80b3b48a0293a136 = ({ onAdmissionRejected: onAdmissionRejected, onLifecycleBoundary: onLifecycleBoundary } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const logLifecycleOperationError = (0, $cozmU.useCallback)((operation, error)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'rendererRemixLifecycleOperation',
                source: 'rendererRemix',
                attributes: {
                    operation: operation,
                    errorName: error instanceof Error ? error.name : typeof error
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const reportCancellationDiagnostic = (0, $cozmU.useCallback)((diagnostic)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'observed',
                actionSubject: 'rendererRemixCancellationShadow',
                source: 'rendererRemix',
                attributes: {
                    diagnosticKind: diagnostic.kind,
                    machinePhase: diagnostic.phase,
                    cancellationScope: diagnostic.scope
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const runLifecycleSafely = (0, $cozmU.useCallback)((operationName, operation)=>{
        try {
            operation();
            return true;
        } catch (error) {
            logLifecycleOperationError(operationName, error);
            return false;
        }
    }, [
        logLifecycleOperationError
    ]);
    const notifyLifecycleBoundary = (0, $cozmU.useCallback)((boundary)=>{
        runLifecycleSafely('notifyLifecycleBoundary', ()=>onLifecycleBoundary?.(boundary));
    }, [
        onLifecycleBoundary,
        runLifecycleSafely
    ]);
    const [remixId, setRemixId] = (0, $cozmU.useState)();
    const phase = (0, $gRoSG.useMachinePhase)(remixId ?? '');
    const phaseRef = (0, $cozmU.useRef)(phase);
    phaseRef.current = phase;
    const remixIdRef = (0, $cozmU.useRef)(undefined);
    const commandRemixIdRef = (0, $cozmU.useRef)(undefined);
    const cancellationSessionIdRef = (0, $cozmU.useRef)(undefined);
    const pendingIntentRef = (0, $cozmU.useRef)(undefined);
    const finalizedRef = (0, $cozmU.useRef)(true);
    const claimFinalization = (0, $cozmU.useCallback)(()=>{
        const activeRemixId = remixIdRef.current;
        if (!activeRemixId || finalizedRef.current) return undefined;
        // Detach the claimed flow before invoking any external callback. A boundary observer may
        // synchronously start another flow, and finalizing this flow must not clear that new owner's
        // identity or cancellation session.
        const cancellationSessionId = cancellationSessionIdRef.current;
        finalizedRef.current = true;
        remixIdRef.current = undefined;
        cancellationSessionIdRef.current = undefined;
        pendingIntentRef.current = undefined;
        return {
            remixId: activeRemixId,
            cancellationSessionId: cancellationSessionId
        };
    }, []);
    const releaseClaimedFlow = (0, $cozmU.useCallback)((finalization)=>{
        if (commandRemixIdRef.current === finalization.remixId) commandRemixIdRef.current = undefined;
        if (finalization.cancellationSessionId) (0, $hwgBi.unregisterRemixCancellationSession)(finalization.cancellationSessionId);
    }, []);
    const safelyEndRemix = (0, $cozmU.useCallback)((id, reason)=>{
        runLifecycleSafely('endRemix', ()=>(0, $bWlOZ.endRemix)(id, reason));
    }, [
        runLifecycleSafely
    ]);
    const endObservedTerminal = (0, $cozmU.useCallback)((reason)=>{
        const finalization = claimFinalization();
        if (!finalization) return;
        const activeRemixId = finalization.remixId;
        try {
            const observedTerminalPhase = $e7504183f26ea064$var$readMachineTerminalPhase(activeRemixId);
            if (observedTerminalPhase) notifyLifecycleBoundary({
                remixId: activeRemixId,
                outcome: 'terminal-applied',
                terminalPhase: observedTerminalPhase
            });
            else notifyLifecycleBoundary({
                remixId: activeRemixId,
                outcome: 'released-unresolved'
            });
            safelyEndRemix(activeRemixId, reason);
        } finally{
            releaseClaimedFlow(finalization);
        }
    }, [
        claimFinalization,
        notifyLifecycleBoundary,
        releaseClaimedFlow,
        safelyEndRemix
    ]);
    const endWith = (0, $cozmU.useCallback)(({ event: event, reason: reason })=>{
        const finalization = claimFinalization();
        if (!finalization) return false;
        const activeRemixId = finalization.remixId;
        let terminalPhaseBeforeSend;
        let didApplyTerminalEvent = false;
        try {
            terminalPhaseBeforeSend = $e7504183f26ea064$var$readMachineTerminalPhase(activeRemixId);
            runLifecycleSafely('sendTerminalEvent', ()=>(0, $bWlOZ.sendRemixEvent)(activeRemixId, {
                    type: event
                }));
            const terminalPhase = $e7504183f26ea064$var$readMachineTerminalPhase(activeRemixId);
            didApplyTerminalEvent = terminalPhaseBeforeSend === undefined && terminalPhase !== undefined;
            if (terminalPhase) notifyLifecycleBoundary({
                remixId: activeRemixId,
                outcome: 'terminal-applied',
                terminalPhase: terminalPhase
            });
            else notifyLifecycleBoundary({
                remixId: activeRemixId,
                outcome: 'released-unresolved'
            });
            safelyEndRemix(activeRemixId, reason);
        } finally{
            releaseClaimedFlow(finalization);
        }
        return didApplyTerminalEvent;
    }, [
        claimFinalization,
        notifyLifecycleBoundary,
        releaseClaimedFlow,
        runLifecycleSafely,
        safelyEndRemix
    ]);
    const startFlow = (0, $cozmU.useCallback)(({ conversationId: requestedConversationId, dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype, source: source })=>{
        const conversationId = requestedConversationId ?? (0, $9HkI0.v4)();
        // Preserve any existing admitted flow. SINGLE_ACTIVE_POLICY owns rejection.
        if (remixIdRef.current && !finalizedRef.current) {
            runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('active-flow'));
            return {
                conversationId: conversationId,
                admitted: false,
                reason: 'active-flow'
            };
        }
        const cancellationSessionId = (0, $hwgBi.registerRemixCancellationSession)({
            conversationId: conversationId,
            reportDiagnostic: reportCancellationDiagnostic
        });
        if (!cancellationSessionId) {
            runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('active-flow'));
            return {
                conversationId: conversationId,
                admitted: false,
                reason: 'active-flow'
            };
        }
        try {
            const result = (0, $bWlOZ.startRemix)({
                kind: 'create',
                conversationId: conversationId,
                cancellationSessionId: cancellationSessionId,
                metadata: {
                    dynamicUiType: dynamicUiType,
                    dynamicUiSubtype: dynamicUiSubtype,
                    source: source
                },
                useCommandBus: true
            });
            if (!result) {
                (0, $hwgBi.unregisterRemixCancellationSession)(cancellationSessionId);
                runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('active-flow'));
                return {
                    conversationId: conversationId,
                    admitted: false,
                    reason: 'active-flow'
                };
            }
            if (result.conversationId !== conversationId) {
                (0, $hwgBi.unregisterRemixCancellationSession)(cancellationSessionId);
                logLifecycleOperationError('validateAdmissionIdentity', new Error('Machine admission returned a different conversation identity'));
                runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('identity-mismatch'));
                safelyEndRemix(result.remixId, 'cancelled');
                return {
                    conversationId: conversationId,
                    admitted: false,
                    reason: 'identity-mismatch'
                };
            }
            finalizedRef.current = false;
            remixIdRef.current = result.remixId;
            commandRemixIdRef.current = result.remixId;
            cancellationSessionIdRef.current = cancellationSessionId;
            pendingIntentRef.current = undefined;
            setRemixId(result.remixId);
            return {
                conversationId: conversationId,
                admitted: true,
                cancellationSessionId: cancellationSessionId
            };
        } catch (error) {
            (0, $hwgBi.unregisterRemixCancellationSession)(cancellationSessionId);
            logLifecycleOperationError('startRemix', error);
            runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('error'));
            return {
                conversationId: conversationId,
                admitted: false,
                reason: 'error'
            };
        }
    }, [
        logLifecycleOperationError,
        onAdmissionRejected,
        reportCancellationDiagnostic,
        runLifecycleSafely,
        safelyEndRemix
    ]);
    const reconcileIntent = (0, $cozmU.useCallback)((intent)=>{
        const activeRemixId = remixIdRef.current;
        if (!activeRemixId || finalizedRef.current) return;
        const currentPhase = phaseRef.current;
        if (intent === 'preview-opened' && currentPhase === 'ready') {
            pendingIntentRef.current = undefined;
            if (!runLifecycleSafely('sendPreviewOpened', ()=>(0, $bWlOZ.sendRemixEvent)(activeRemixId, {
                    type: 'PREVIEW_OPENED'
                }))) {
                const finalization = claimFinalization();
                if (finalization) try {
                    notifyLifecycleBoundary({
                        remixId: finalization.remixId,
                        outcome: 'released-unresolved'
                    });
                    safelyEndRemix(finalization.remixId, 'cancelled');
                } finally{
                    releaseClaimedFlow(finalization);
                }
            }
            return;
        }
    }, [
        claimFinalization,
        notifyLifecycleBoundary,
        releaseClaimedFlow,
        runLifecycleSafely,
        safelyEndRemix
    ]);
    const onPreviewOpened = (0, $cozmU.useCallback)(()=>{
        if (remixIdRef.current && !finalizedRef.current) {
            pendingIntentRef.current = 'preview-opened';
            reconcileIntent('preview-opened');
        }
    }, [
        reconcileIntent
    ]);
    const onPreviewDismissed = (0, $cozmU.useCallback)(()=>{
        return endWith({
            event: 'CANCELLED',
            reason: 'cancelled'
        });
    }, [
        endWith
    ]);
    const onStopThinking = (0, $cozmU.useCallback)(()=>{
        const activeRemixId = remixIdRef.current;
        const currentPhase = activeRemixId ? (0, $bWlOZ.getRemixMachine)(activeRemixId)?.state() : undefined;
        return endWith({
            event: currentPhase === 'thinking' ? 'GENERATION_ABORTED' : 'CANCELLED',
            reason: 'aborted'
        });
    }, [
        endWith
    ]);
    const onRovoAborted = (0, $cozmU.useCallback)(()=>{
        endObservedTerminal('aborted');
    }, [
        endObservedTerminal
    ]);
    const onErrorDismissed = (0, $cozmU.useCallback)(()=>{
        endObservedTerminal('cancelled');
    }, [
        endObservedTerminal
    ]);
    const onSendRejected = (0, $cozmU.useCallback)(()=>{
        return endWith({
            event: 'GENERATION_ERROR',
            reason: 'error'
        });
    }, [
        endWith
    ]);
    const onNavigation = (0, $cozmU.useCallback)(()=>{
        return endWith({
            event: 'CANCELLED',
            reason: 'cancelled'
        });
    }, [
        endWith
    ]);
    (0, $cozmU.useEffect)(()=>{
        const pendingIntent = pendingIntentRef.current;
        if (!pendingIntent) return;
        // Reconcile the queued renderer intent only after the watcher exposes a legal machine phase.
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        reconcileIntent(pendingIntent);
    }, [
        phase,
        reconcileIntent
    ]);
    // Component teardown mirrors legacy dismissal and releases machine admission.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            const finalization = claimFinalization();
            if (!finalization) return;
            const activeRemixId = finalization.remixId;
            try {
                runLifecycleSafely('sendUnmountCancelled', ()=>(0, $bWlOZ.sendRemixEvent)(activeRemixId, {
                        type: 'CANCELLED'
                    }));
                safelyEndRemix(activeRemixId, 'cancelled');
            } finally{
                releaseClaimedFlow(finalization);
            }
        };
    }, [
        claimFinalization,
        releaseClaimedFlow,
        runLifecycleSafely,
        safelyEndRemix
    ]);
    const isAdmittedRemixId = (0, $cozmU.useCallback)((id)=>commandRemixIdRef.current === id, []);
    return {
        phase: phase,
        remixId: remixId,
        isAdmittedRemixId: isAdmittedRemixId,
        startFlow: startFlow,
        onPreviewOpened: onPreviewOpened,
        onPreviewDismissed: onPreviewDismissed,
        onStopThinking: onStopThinking,
        onRovoAborted: onRovoAborted,
        onErrorDismissed: onErrorDismissed,
        onSendRejected: onSendRejected,
        onNavigation: onNavigation
    };
};
module.exports["useRendererRemixMachineLifecycle"] = $e7504183f26ea064$export$80b3b48a0293a136;

});

parcelRegister("8L2yq", function(module, exports) {
/**
 * Reports when the renderer's legacy lifecycle and the Remix state machine settle on different
 * phases. This is a read-only observer: it derives nothing the renderer does not already compute for
 * itself, and it never participates in renderer behavior.
 *
 * Classification lives in `rendererRemixParity.ts`; this session-owned hook accepts observations
 * from the renderer UI and authoritative boundaries from the lifecycle owner. Keeping retained
 * state here means closing the visible renderer cannot erase a flow that is still active.
 */ 
var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $30OJC = parcelRequire("30OJC");


var $29oXT = parcelRequire("29oXT");


var $nkPkg = parcelRequire("nkPkg");

/**
 * How long a non-terminal phase pair must hold before it counts as settled.
 *
 * Legacy readiness and the machine's watcher-driven phase land on different ticks, so a healthy
 * flow briefly reports two different phases at every transition. Reporting only what survives this
 * delay keeps that ordinary skew out of the signal.
 *
 * This delay is deliberately not applied once the machine is terminal — see the comment at the
 * report site.
 */ const $d21c0166676c8f4f$var$PARITY_SETTLE_MS = 250;
const $d21c0166676c8f4f$export$a819d3c7b26e01bc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportedRef = (0, $cozmU.useRef)();
    const pendingTerminalRef = (0, $cozmU.useRef)(undefined);
    const pendingMechanicsRef = (0, $cozmU.useRef)(undefined);
    const reportedMechanicRef = (0, $cozmU.useRef)(undefined);
    const pendingBoundaryRef = (0, $cozmU.useRef)(undefined);
    const lastTrackedObservationRef = (0, $cozmU.useRef)(undefined);
    const reportDivergence = (0, $cozmU.useCallback)((flowRemixId, pairLegacyPhase, pairMachinePhase, reasonOverride)=>{
        const settled = (0, $29oXT.compareRendererRemixParity)({
            legacyPhase: pairLegacyPhase,
            machinePhase: pairMachinePhase,
            isStable: true
        });
        if (settled.outcome !== 'divergence') return;
        // Each admitted flow reports a given divergence once, so a divergence that persists across
        // many renders does not become a flood of identical events.
        const previous = reportedRef.current;
        const reported = previous?.remixId === flowRemixId ? previous : {
            remixId: flowRemixId,
            signatures: new Set()
        };
        reportedRef.current = reported;
        const divergenceReason = reasonOverride ?? settled.divergence.divergenceReason;
        if (divergenceReason === 'unexpected-phase-pair') return;
        const severeDivergence = {
            ...settled.divergence,
            divergenceReason: divergenceReason
        };
        if (pendingMechanicsRef.current?.remixId === flowRemixId) // A definitive severe disposition closes every mechanic retained for this flow. None of
        // them converged, so discard them without emitting misleading resolved events.
        pendingMechanicsRef.current = undefined;
        const signature = (0, $30OJC.createDivergenceSignature)(severeDivergence);
        if (reported.signatures.has(signature)) return;
        reported.signatures.add(signature);
        (0, $30OJC.dispatchRendererRemixParityEvent)(createAnalyticsEvent, severeDivergence);
    }, [
        createAnalyticsEvent
    ]);
    const reportMechanicObserved = (0, $cozmU.useCallback)((flowRemixId, legacyPhase, machinePhase)=>{
        const result = (0, $29oXT.compareRendererRemixParity)({
            legacyPhase: legacyPhase,
            machinePhase: machinePhase,
            isStable: true
        });
        if (result.outcome !== 'divergence' || result.divergence.divergenceReason !== 'unexpected-phase-pair') return;
        const previous = reportedMechanicRef.current;
        const reported = previous?.remixId === flowRemixId ? previous : {
            remixId: flowRemixId,
            signatures: new Set()
        };
        reportedMechanicRef.current = reported;
        const signature = (0, $30OJC.createDivergenceSignature)(result.divergence);
        if (reported.signatures.has(signature)) return;
        reported.signatures.add(signature);
        const pending = pendingMechanicsRef.current?.remixId === flowRemixId ? pendingMechanicsRef.current : {
            remixId: flowRemixId,
            observations: new Map()
        };
        pendingMechanicsRef.current = pending;
        pending.observations.set(signature, {
            legacyPhase: legacyPhase,
            machinePhase: machinePhase,
            comparisonPoint: result.divergence.comparisonPoint,
            startedAt: Date.now() - $d21c0166676c8f4f$var$PARITY_SETTLE_MS
        });
        (0, $30OJC.dispatchRendererRemixParityMechanicEvent)(createAnalyticsEvent, {
            legacyPhase: legacyPhase,
            machinePhase: machinePhase,
            comparisonPoint: result.divergence.comparisonPoint,
            action: 'observed',
            outcome: 'timing-skew',
            reason: 'awaiting-convergence',
            durationBucket: (0, $nkPkg.durationBucketForMs)($d21c0166676c8f4f$var$PARITY_SETTLE_MS)
        });
    }, [
        createAnalyticsEvent
    ]);
    const resolveMechanics = (0, $cozmU.useCallback)((flowRemixId)=>{
        const pending = pendingMechanicsRef.current;
        if (!pending || pending.remixId !== flowRemixId) return;
        pendingMechanicsRef.current = undefined;
        for (const observation of pending.observations.values())(0, $30OJC.dispatchRendererRemixParityMechanicEvent)(createAnalyticsEvent, {
            legacyPhase: observation.legacyPhase,
            machinePhase: observation.machinePhase,
            comparisonPoint: observation.comparisonPoint,
            action: 'resolved',
            outcome: 'converged',
            reason: 'phase-converged',
            durationBucket: (0, $nkPkg.durationBucketForMs)(Date.now() - observation.startedAt)
        });
    }, [
        createAnalyticsEvent
    ]);
    const reportAndClearPendingTerminalMismatch = (0, $cozmU.useCallback)((machineTerminalPhase, reasonOverride)=>{
        const pending = pendingTerminalRef.current;
        if (!pending) return;
        reportDivergence(pending.remixId, pending.legacyPhase, machineTerminalPhase ?? pending.machinePhase, reasonOverride);
        pendingTerminalRef.current = undefined;
    }, [
        reportDivergence
    ]);
    const recordLifecycleBoundary = (0, $cozmU.useCallback)((boundary)=>{
        const pending = pendingTerminalRef.current;
        if (!pending || pending.remixId !== boundary.remixId) {
            const mechanics = pendingMechanicsRef.current;
            if (mechanics?.remixId === boundary.remixId) {
                if (boundary.outcome === 'released-unresolved') {
                    let latestMechanic;
                    for (const observation of mechanics.observations.values())latestMechanic = observation;
                    if (!latestMechanic) return;
                    reportDivergence(mechanics.remixId, latestMechanic.legacyPhase, latestMechanic.machinePhase, 'released-unresolved');
                } else // A terminal-applied boundary is not itself a mismatch. Retain it so the later legacy
                // terminal observation can decide whether the mechanic converged or contradicted it.
                pendingBoundaryRef.current = boundary;
                return;
            }
            // Renderer state is observed in a passive effect, while lifecycle finalization can happen
            // synchronously in the event callback that changes legacy state. Retain the boundary so the
            // later terminal observation can reconcile against it regardless of arrival order.
            // If no observation ever arrives, there is no phase pair to classify; emitting then would
            // fabricate parity evidence rather than report an observed divergence.
            pendingBoundaryRef.current = boundary;
            return;
        }
        if (boundary.outcome === 'terminal-applied') {
            if (pending.legacyPhase === boundary.terminalPhase) {
                pendingTerminalRef.current = undefined;
                resolveMechanics(boundary.remixId);
                return;
            }
            reportAndClearPendingTerminalMismatch(boundary.terminalPhase);
            return;
        }
        reportAndClearPendingTerminalMismatch(undefined, 'released-unresolved');
    }, [
        reportAndClearPendingTerminalMismatch,
        reportDivergence,
        resolveMechanics
    ]);
    const recordObservation = (0, $cozmU.useCallback)(({ enabled: enabled, remixId: remixId, legacyPhase: legacyPhase, machinePhase: machinePhase })=>{
        if (!enabled || remixId === undefined) {
            pendingTerminalRef.current = undefined;
            pendingMechanicsRef.current = undefined;
            reportedMechanicRef.current = undefined;
            pendingBoundaryRef.current = undefined;
            lastTrackedObservationRef.current = undefined;
            return;
        }
        const pending = pendingTerminalRef.current;
        if (pending && pending.remixId !== remixId) // A new admitted flow is a definitive boundary for the pending flow. It ended without the
        // machine ever exposing the matching terminal outcome to this observer.
        reportAndClearPendingTerminalMismatch();
        if (pendingMechanicsRef.current?.remixId !== remixId) {
            pendingMechanicsRef.current = undefined;
            reportedMechanicRef.current = undefined;
        }
        if (pendingBoundaryRef.current?.remixId !== remixId) pendingBoundaryRef.current = undefined;
        if (lastTrackedObservationRef.current?.remixId !== remixId) lastTrackedObservationRef.current = undefined;
        const pendingBoundary = pendingBoundaryRef.current;
        if (pendingBoundary?.remixId === remixId && (0, $29oXT.isTerminalPhase)(legacyPhase)) {
            const lastTrackedMachinePhase = lastTrackedObservationRef.current?.machinePhase;
            pendingBoundaryRef.current = undefined;
            pendingTerminalRef.current = undefined;
            if (pendingBoundary.outcome === 'terminal-applied') {
                if (legacyPhase !== pendingBoundary.terminalPhase) reportDivergence(remixId, legacyPhase, pendingBoundary.terminalPhase);
                else resolveMechanics(remixId);
            } else if (lastTrackedMachinePhase) reportDivergence(remixId, legacyPhase, lastTrackedMachinePhase, 'released-unresolved');
            return;
        }
        if (machinePhase === 'inactive') // `inactive` is only a render snapshot. The lifecycle owner separately records whether a
        // terminal event was applied or the flow was released unresolved, so do not infer here.
        return;
        lastTrackedObservationRef.current = {
            enabled: enabled,
            remixId: remixId,
            legacyPhase: legacyPhase,
            machinePhase: machinePhase
        };
        const currentPending = pendingTerminalRef.current;
        if (currentPending?.remixId === remixId) {
            if ((0, $29oXT.isTerminalPhase)(machinePhase)) {
                if (currentPending.legacyPhase === machinePhase) {
                    pendingTerminalRef.current = undefined;
                    resolveMechanics(remixId);
                } else reportAndClearPendingTerminalMismatch(machinePhase);
                return;
            }
            if ((0, $29oXT.isTerminalPhase)(legacyPhase) && currentPending.legacyPhase !== legacyPhase) // A terminal legacy outcome cannot legitimately change while the same machine flow is
            // live. Preserve the first contradiction before retaining the new expectation.
            reportAndClearPendingTerminalMismatch();
            else {
                // Once legacy has reached a terminal outcome, retain that expectation for the flow.
                // Later legacy cleanup renders cannot prove convergence or erase the observation.
                currentPending.machinePhase = machinePhase;
                return;
            }
        }
        if (legacyPhase === machinePhase) {
            resolveMechanics(remixId);
            pendingTerminalRef.current = undefined;
            return;
        }
        const reportSettledPair = ()=>{
            const result = (0, $29oXT.compareRendererRemixParity)({
                legacyPhase: legacyPhase,
                machinePhase: machinePhase,
                isStable: true
            });
            if (result.outcome !== 'divergence') return;
            if (result.divergence.divergenceReason === 'unexpected-phase-pair') reportMechanicObserved(remixId, legacyPhase, machinePhase);
            else reportDivergence(remixId, legacyPhase, machinePhase);
        };
        // A terminal machine phase is already final, and deferring it would lose the observation: in
        // treatment the renderer's error and abort effects are driven by the machine phase and call
        // `onClose`, which clears the modal session and unmounts this observer in the same cycle,
        // clearing any pending timer. Report now or never.
        //
        // The mirror case is deliberately not fast-pathed. During an ordinary error or abort the
        // legacy phase updates during render while the machine catches up in a later effect, so a
        // terminal legacy phase against a live machine is expected lag rather than a divergence. Those
        // pairs remain pending until the machine reaches a definitive lifecycle boundary.
        if ((0, $29oXT.isTerminalPhase)(machinePhase)) {
            pendingTerminalRef.current = undefined;
            reportSettledPair();
            return;
        }
        if ((0, $29oXT.isTerminalPhase)(legacyPhase)) {
            const previous = pendingTerminalRef.current;
            if (previous?.remixId === remixId && previous.legacyPhase === legacyPhase) {
                previous.machinePhase = machinePhase;
                return;
            }
            pendingTerminalRef.current = {
                remixId: remixId,
                legacyPhase: legacyPhase,
                machinePhase: machinePhase
            };
            return;
        }
        pendingTerminalRef.current = undefined;
        const timeout = setTimeout(reportSettledPair, $d21c0166676c8f4f$var$PARITY_SETTLE_MS);
        return ()=>clearTimeout(timeout);
    }, [
        reportAndClearPendingTerminalMismatch,
        reportDivergence,
        reportMechanicObserved,
        resolveMechanics
    ]);
    const recordLegacyTerminal = (0, $cozmU.useCallback)((remixId, phase)=>{
        const lastTracked = lastTrackedObservationRef.current;
        if (!remixId || lastTracked?.remixId !== remixId) return;
        // A terminal legacy phase never enters the delayed non-terminal branch today. Dispose
        // defensively anyway so a future branch reordering cannot leak a timer from this
        // synchronous path.
        recordObservation({
            ...lastTracked,
            legacyPhase: phase
        })?.();
    }, [
        recordObservation
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            // Ending observation is not proof of divergence. The session owner has gone away, so any
            // retained pair is deliberately discarded without classification.
            pendingTerminalRef.current = undefined;
            pendingMechanicsRef.current = undefined;
            reportedMechanicRef.current = undefined;
            pendingBoundaryRef.current = undefined;
            lastTrackedObservationRef.current = undefined;
        }, []);
    return (0, $cozmU.useMemo)(()=>({
            recordObservation: recordObservation,
            recordLifecycleBoundary: recordLifecycleBoundary,
            recordLegacyTerminal: recordLegacyTerminal
        }), [
        recordLegacyTerminal,
        recordLifecycleBoundary,
        recordObservation
    ]);
};
module.exports["useRendererRemixParityDiagnostics"] = $d21c0166676c8f4f$export$a819d3c7b26e01bc;

});

parcelRegister("30OJC", function(module, exports) {
/**
 * Builds and fires the bounded operational event for a renderer Remix parity divergence.
 *
 * Every attribute is drawn from a closed union, so the payload carries no flow identifier, no
 * content reference, and no user content.
 *
 * `treatmentPhase` records the migration phase the event was observed in. Diagnostics only run
 * under `isMachineReadTreatment`, so today the only value is `machine-read`; it exists to keep
 * events from this phase distinguishable once the authority cutover (CCCEMAU-3480) changes what the
 * renderer reads.
 */ const $5f613e881c11497b$export$faea11873c201815 = ({ legacyPhase: legacyPhase, machinePhase: machinePhase, comparisonPoint: comparisonPoint, divergenceReason: divergenceReason })=>`${legacyPhase}|${machinePhase}|${comparisonPoint}|${divergenceReason}`;
const $5f613e881c11497b$export$c736feea7617c718 = (createAnalyticsEvent, { legacyPhase: legacyPhase, machinePhase: machinePhase, comparisonPoint: comparisonPoint, divergenceReason: divergenceReason })=>{
    try {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'diverged',
                actionSubject: 'rendererRemixStateParity',
                source: 'rendererRemix',
                tags: [
                    'remix',
                    'stateRearchitecture'
                ],
                attributes: {
                    entryPoint: 'renderer',
                    severity: 'critical',
                    outcome: divergenceReason === 'terminal-outcome-mismatch' ? 'terminal-mismatch' : 'released-unresolved',
                    reason: divergenceReason,
                    legacyPhase: legacyPhase,
                    machinePhase: machinePhase,
                    comparisonPoint: comparisonPoint,
                    divergenceReason: divergenceReason,
                    treatmentPhase: 'machine-read'
                }
            }
        }).fire();
    } catch  {
    // Diagnostics must never affect the renderer flow.
    }
};
const $5f613e881c11497b$export$c296f4fbda0fd8b1 = (createAnalyticsEvent, { legacyPhase: legacyPhase, machinePhase: machinePhase, comparisonPoint: comparisonPoint, action: action, outcome: outcome, reason: reason, durationBucket: durationBucket })=>{
    try {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: action,
                actionSubject: 'rendererRemixParityMechanic',
                source: 'rendererRemix',
                tags: [
                    'remix',
                    'stateRearchitecture'
                ],
                attributes: {
                    entryPoint: 'renderer',
                    severity: 'info',
                    outcome: outcome,
                    reason: reason,
                    legacyPhase: legacyPhase,
                    machinePhase: machinePhase,
                    comparisonPoint: comparisonPoint,
                    durationBucket: durationBucket,
                    treatmentPhase: 'machine-read'
                }
            }
        }).fire();
    } catch  {
    // Diagnostics must never affect the renderer flow.
    }
};
module.exports["createDivergenceSignature"] = $5f613e881c11497b$export$faea11873c201815;
module.exports["dispatchRendererRemixParityEvent"] = $5f613e881c11497b$export$c736feea7617c718;
module.exports["dispatchRendererRemixParityMechanicEvent"] = $5f613e881c11497b$export$c296f4fbda0fd8b1;

});

parcelRegister("29oXT", function(module, exports) {
/**
 * Pure comparison of the renderer's legacy lifecycle against the Remix state machine.
 *
 * Both phases are expressed in the renderer's existing `RendererRemixLifecyclePhase` vocabulary, so
 * diagnostics introduce no second normalization of renderer state. Nothing here reads or mutates
 * runtime state: callers pass two phases plus whether the pair has settled, and get back a
 * classification. Timing is the caller's concern.
 */ const $0777f04525ed21e4$var$COMPARISON_POINT_BY_LEGACY_PHASE = {
    inactive: 'released',
    thinking: 'flow-started',
    ready: 'result-ready',
    previewing: 'preview-opened',
    submitting: 'submitted',
    error: 'error',
    aborted: 'aborted'
};
const $0777f04525ed21e4$export$b2aaa5bc54318fb1 = (legacyPhase)=>$0777f04525ed21e4$var$COMPARISON_POINT_BY_LEGACY_PHASE[legacyPhase];
const $0777f04525ed21e4$export$9828bb32a038414e = (phase)=>phase === 'error' || phase === 'aborted';
const $0777f04525ed21e4$export$d239298095fe15f0 = (legacyPhase, machinePhase)=>{
    // The machine is running a flow the renderer no longer considers active.
    if (legacyPhase === 'inactive') return 'legacy-not-tracking';
    if ($0777f04525ed21e4$export$9828bb32a038414e(legacyPhase) || $0777f04525ed21e4$export$9828bb32a038414e(machinePhase)) return 'terminal-outcome-mismatch';
    return 'unexpected-phase-pair';
};
const $0777f04525ed21e4$export$78e12f3697c824a9 = ({ legacyPhase: legacyPhase, machinePhase: machinePhase, isStable: isStable })=>{
    // `inactive` covers both admission skew and a released machine flow. Machine release clears the
    // imperative remixId ref but retains the React remixId state, so this observer can continue
    // reading the released flow for the remaining modal lifetime. Comparing here would therefore
    // report normal teardown as a divergence; terminal pairs must be captured before the machine is
    // released. The machine's own release paths are instrumented separately by
    // `useRendererRemixMachineLifecycle`.
    if (machinePhase === 'inactive') return {
        outcome: 'pending',
        reason: 'machine-not-tracking'
    };
    if (legacyPhase === machinePhase) return {
        outcome: 'match'
    };
    if (!isStable) return {
        outcome: 'pending',
        reason: 'awaiting-stable-phases'
    };
    return {
        outcome: 'divergence',
        divergence: {
            legacyPhase: legacyPhase,
            machinePhase: machinePhase,
            comparisonPoint: $0777f04525ed21e4$export$b2aaa5bc54318fb1(legacyPhase),
            divergenceReason: $0777f04525ed21e4$export$d239298095fe15f0(legacyPhase, machinePhase)
        }
    };
};
module.exports["isTerminalPhase"] = $0777f04525ed21e4$export$9828bb32a038414e;
module.exports["compareRendererRemixParity"] = $0777f04525ed21e4$export$78e12f3697c824a9;

});

parcelRegister("2Jxlo", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8c38d1311bce6ee3$export$15b21f0ead27e4bf = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qNGEh",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("34IJw"))).ReadingAidsPopup
});
module.exports["ReadingAidsPopup"] = $8c38d1311bce6ee3$export$15b21f0ead27e4bf;

});

parcelRegister("34IJw", function(module, exports) {

let $23d471e2c855c648$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $23d471e2c855c648$var$load("kT6dz"),
    $23d471e2c855c648$var$load("9Xw1v"),
    $23d471e2c855c648$var$load("dbmgs"),
    $23d471e2c855c648$var$load("8Lsss"),
    $23d471e2c855c648$var$load("8TYN0"),
    $23d471e2c855c648$var$load("9i6sC"),
    $23d471e2c855c648$var$load("hUbK8"),
    $23d471e2c855c648$var$load("4oHR8"),
    $23d471e2c855c648$var$load("5KHgm"),
    $23d471e2c855c648$var$load("fcAaN"),
    $23d471e2c855c648$var$load("alg5Q"),
    $23d471e2c855c648$var$load("h5PR1"),
    $23d471e2c855c648$var$load("1Gr4q"),
    $23d471e2c855c648$var$load("2mGc6"),
    $23d471e2c855c648$var$load("7pX1O"),
    $23d471e2c855c648$var$load("7BC5e"),
    $23d471e2c855c648$var$load("kccW9"),
    $23d471e2c855c648$var$load("4dKZ4"),
    $23d471e2c855c648$var$load("8yk9S"),
    $23d471e2c855c648$var$load("iOfkQ"),
    $23d471e2c855c648$var$load("eeYoU"),
    $23d471e2c855c648$var$load("7SteV"),
    $23d471e2c855c648$var$load("1cQg7"),
    $23d471e2c855c648$var$load("3TR44"),
    $23d471e2c855c648$var$load("kUh5E"),
    $23d471e2c855c648$var$load("dxcsb"),
    $23d471e2c855c648$var$load("jqoep"),
    $23d471e2c855c648$var$load("7EsNO"),
    $23d471e2c855c648$var$load("3vH95"),
    $23d471e2c855c648$var$load("fnO1K"),
    $23d471e2c855c648$var$load("aLwQm"),
    $23d471e2c855c648$var$load("ajcqE"),
    $23d471e2c855c648$var$load("7iw60"),
    $23d471e2c855c648$var$load("1YU2Y"),
    $23d471e2c855c648$var$load("4GjU8"),
    $23d471e2c855c648$var$load("fKQ9j"),
    $23d471e2c855c648$var$load("39lxd"),
    $23d471e2c855c648$var$load("aJH6e"),
    $23d471e2c855c648$var$load("4x9Jx"),
    $23d471e2c855c648$var$load("ea3NB"),
    $23d471e2c855c648$var$load("6wr18"),
    $23d471e2c855c648$var$load("59hV4"),
    $23d471e2c855c648$var$load("fibpY"),
    $23d471e2c855c648$var$load("4O6U4"),
    $23d471e2c855c648$var$load("ffEVr"),
    $23d471e2c855c648$var$load("lya9W"),
    $23d471e2c855c648$var$load("do0Fh"),
    $23d471e2c855c648$var$load("arr2H"),
    $23d471e2c855c648$var$load("9jDcd"),
    $23d471e2c855c648$var$load("6hXmJ"),
    $23d471e2c855c648$var$load("fwbNS"),
    $23d471e2c855c648$var$load("aMg3L"),
    $23d471e2c855c648$var$load("313PM"),
    $23d471e2c855c648$var$load("Wowvf"),
    $23d471e2c855c648$var$load("29XrG"),
    $23d471e2c855c648$var$load("Lm7SH"),
    $23d471e2c855c648$var$load("hhss7"),
    $23d471e2c855c648$var$load("7EorR"),
    $23d471e2c855c648$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});


//# sourceMappingURL=PageContentRendererFabric.4c717509.js.map
